module.exports = __webpack_public_path__ + "static/media/facebook.ec206f7f.svg";